/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Other_SubtitleInputs */

const en_admin_resources_other_subtitle = /** @type {(inputs: Admin_Resources_Other_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipment, parking spot, locker`)
};

const de_admin_resources_other_subtitle = /** @type {(inputs: Admin_Resources_Other_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausstattung, Parkplatz, Schließfach`)
};

const es_admin_resources_other_subtitle = /** @type {(inputs: Admin_Resources_Other_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipamiento, plaza de aparcamiento, taquilla`)
};

const fr_admin_resources_other_subtitle = /** @type {(inputs: Admin_Resources_Other_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipement, place de parking, casier`)
};

const nl_admin_resources_other_subtitle = /** @type {(inputs: Admin_Resources_Other_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apparatuur, parkeerplaats, locker`)
};

/** @type {(inputs: Admin_Resources_Other_SubtitleInputs) => LocalizedString} */
const it_admin_resources_other_subtitle = en_admin_resources_other_subtitle;

/** @type {(inputs: Admin_Resources_Other_SubtitleInputs) => LocalizedString} */
const pt_br2_admin_resources_other_subtitle = en_admin_resources_other_subtitle;

/** @type {(inputs: Admin_Resources_Other_SubtitleInputs) => LocalizedString} */
const pl_admin_resources_other_subtitle = en_admin_resources_other_subtitle;

/** @type {(inputs: Admin_Resources_Other_SubtitleInputs) => LocalizedString} */
const hu_admin_resources_other_subtitle = en_admin_resources_other_subtitle;

/** @type {(inputs: Admin_Resources_Other_SubtitleInputs) => LocalizedString} */
const ro_admin_resources_other_subtitle = en_admin_resources_other_subtitle;

/**
* | output |
* | --- |
* | "Equipment, parking spot, locker" |
*
* @param {Admin_Resources_Other_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_other_subtitle = /** @type {((inputs?: Admin_Resources_Other_SubtitleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Other_SubtitleInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_other_subtitle(inputs)
	if (locale === "de") return de_admin_resources_other_subtitle(inputs)
	if (locale === "es") return es_admin_resources_other_subtitle(inputs)
	if (locale === "fr") return fr_admin_resources_other_subtitle(inputs)
	if (locale === "nl") return nl_admin_resources_other_subtitle(inputs)
	if (locale === "it") return it_admin_resources_other_subtitle(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_other_subtitle(inputs)
	if (locale === "pl") return pl_admin_resources_other_subtitle(inputs)
	if (locale === "hu") return hu_admin_resources_other_subtitle(inputs)
	return ro_admin_resources_other_subtitle(inputs)
});
export { admin_resources_other_subtitle as "admin.resources.other_subtitle" }